import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const PUBLIC_BASE_URL = process.env.REACT_APP_PUBLIC_BASE_URL;

export const getAllCountries = createAsyncThunk(
    'country/getAllCountries',
    async ({ skip, limit, search, status }, { rejectWithValue }) => {
        try {
            const params = {};
            if (skip !== undefined) params.skip = skip;
            if (limit !== undefined) params.limit = limit;
            if (search) params.search = search;
            if (status) params.status = status;

            const config = {
                headers: {
                    "Content-Type": "application/json",
                },
                withCredentials: true,
                params,
            };

            const response = await axios.get(`${PUBLIC_BASE_URL}/country`, config);
            return (response.data);

        } catch (err) {
            if (err.message === "Network Error") {
                return rejectWithValue({
                    response: {
                        data: {
                            message: "Network Error",
                            status: err.code,
                            statusText: err.code,
                        },
                    },
                });
            } else {
                return rejectWithValue(
                    err.response?.data?.message || 'An error occurred'
                );
            }
        }
    }
);

export const addNewCountry = createAsyncThunk(
    'country/addNewCountry',
    async (countryData, { rejectWithValue }) => {
        try {
            const config = {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
                withCredentials: true,
            };

            const formData = new FormData();

            formData.append("name", countryData.name);
            formData.append("image", countryData.file);

            const response = await axios.post(`${PUBLIC_BASE_URL}/country/create-country`, formData, config);
            return response.data;
        } catch (err) {
            if (err.message === "Network Error") {
                return rejectWithValue({
                    message: "Network Error",
                    status: err.code,
                    success: false
                });
            } else {
                return rejectWithValue(err.response?.data || 'Unknown error occurred.');
            }
        }
    }
);

export const editCountry = createAsyncThunk(
    'country/editCountry',
    async (updatedData, { rejectWithValue }) => {
        try {

            const config = {
                headers: {
                    "Content-Type": "application/json",
                },
                withCredentials: true,
            };

            const body = JSON.stringify(updatedData);

            const response = await axios.put(`${PUBLIC_BASE_URL}/country/update-country-info`, body, config);
            return response.data;
        } catch (err) {
            if (err.message === "Network Error") {
                return rejectWithValue({
                    message: "Network Error",
                    status: err.code,
                    success: false
                });
            } else {
                return rejectWithValue(err.response?.data || 'Unknown error occurred.');
            }
        }
    }
);

export const editCountryImage = createAsyncThunk(
    'country/editCountryImage',
    async (data, { rejectWithValue }) => {
        try {
            const config = {
                headers: {
                    'Content-Type': 'multipart/form-data',

                },
                withCredentials: true,
            };

            const formData = new FormData();
            if (data.file) formData.append('image', data.file);
            if (data.id) formData.append('countryId', data.id);

            const response = await axios.put(
                `${PUBLIC_BASE_URL}/country/update-image`,
                formData,
                config
            );
            return response.data;
        } catch (err) {
            if (err.message === 'Network Error') {
                return rejectWithValue({
                    message: 'Network Error',
                    status: 404,
                    statusText: err.code,
                });
            } else {
                return rejectWithValue(err.response?.data || 'Unknown error occurred');
            }
        }
    }
);